import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class SignInService {

    constructor(
        private http: HttpClient
    ) { }

    verifyEmailId(emailId) {
        return this.http.get(environment.serverUrl + '/user/verifyEmailId/' + emailId);
    }

    login(user) {
        return this.http.post(environment.serverUrl + '/user/login', user);
    }
    verifyTeam(teamName) {
        return this.http.post(environment.serverUrl + '/verifyTeam', teamName);
    }
    forgotPassword(emailObj) {
        return this.http.post(environment.serverUrl + '/user/forgot-password', emailObj);
    }
}



// WEBPACK FOOTER //
// ./src/app/sign-in/sign-in.service.ts